import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { LogoComponent } from '@shared/logo/logo.component';
import { HeaderNavigation } from '../header.type';
import { ClickOutsideDirective } from '@shared/click-outside/click-outside.directive';
import { AssetPipe } from '@shared/asset/asset.pipe';
import { DisabledScrollDirective } from '@shared/disable-scroll/disabled-scroll.directive';
import { SocialMediaComponent } from '@shared/social-media/social-media.component';
import { LanguageSwitcherComponent } from '@shared/language-switcher/language-switcher.component';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'companyid-mobile-navbar',
    imports: [
        NgOptimizedImage,
        LogoComponent,
        ClickOutsideDirective,
        AssetPipe,
        DisabledScrollDirective,
        SocialMediaComponent,
        LanguageSwitcherComponent,
        RouterLink,
    ],
    templateUrl: './mobile-navbar.component.html',
    styleUrl: './mobile-navbar.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileNavbarComponent {
    public showNav = false;
    public navigation = input.required<HeaderNavigation[]>();

    public toggleNavBlock(): void {
        this.showNav = !this.showNav;
    }
    public onClickOutside(): void {
        this.toggleNavBlock();
    }
}
